import React from 'react';
import { GlobalToken, Modal } from 'antd';
import styled from 'styled-components';
import { EPButton } from '@/components';
import { useTranslation } from 'react-i18next';

interface ConfirmationModalProps {
  isVisible: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({ isVisible, onConfirm, onCancel }) => {
  const { t } = useTranslation();
  return (
    <StyledModal open={isVisible} onCancel={onCancel} maskClosable={false} width={520} centered closable={true}>
      <div className="modal-header">
        <div className="modal-header-text">{t('confirmSubmission')}</div>
      </div>
      <div className="modal-content">
        <div className="context-text">{t('SUBMIT_CONFIRMATION_MESSAGE')}</div>
      </div>
      <ModalActions>
        <EPButton onClick={onConfirm} type="primary">
          {t('SUBMIT_REPORT')}
        </EPButton>
      </ModalActions>
    </StyledModal>
  );
};

const StyledModal = styled(Modal)<{ theme: { token: GlobalToken } }>`
  .ant-modal-content {
    background: ${({ theme: { token } }) => token.colorBgContainer};
    border-radius: ${({ theme: { token } }) => token.borderRadiusLG}px;
    padding: 0;
    width: 520px;
  }

  .ant-modal-body {
    padding: 0;
  }

  .ant-modal-footer {
    display: none;
  }

  .ant-modal-close {
    width: ${({ theme: { token } }) => token.controlHeight}px;
    height: ${({ theme: { token } }) => token.controlHeight}px;
    right: ${({ theme: { token } }) => token.padding}px;
    top: ${({ theme: { token } }) => token.paddingLG}px;

    &:hover {
      background: ${({ theme: { token } }) => token.colorBgTextHover};
      border-radius: ${({ theme: { token } }) => token.borderRadius}px;
    }

    .ant-modal-close-x {
      width: ${({ theme: { token } }) => token.controlHeight}px;
      height: ${({ theme: { token } }) => token.controlHeight}px;
      line-height: ${({ theme: { token } }) => token.controlHeight}px;
      font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
      color: ${({ theme: { token } }) => token.colorTextLightSolid};
    }
  }

  .modal-header {
    padding: ${({ theme: { token } }) => `${token.paddingLG}px ${token.padding}px ${token.paddingXS}px`};
    display: flex;
    align-items: center;
  }

  .modal-content {
    padding: ${({ theme: { token } }) => `0 ${token.padding}px ${token.paddingXS}px`};
    display: flex;
    align-items: center;
  }

  .modal-header-text {
    color: ${({ theme: { token } }) => token.colorTextHeading};
    font-family: ${({ theme: { token } }) => token.fontFamily};
    font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
    font-style: normal;
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
    line-height: ${({ theme: { token } }) => token.lineHeightLG};
  }

  .context-text {
    color: ${({ theme: { token } }) => token.colorText};
    font-family: ${({ theme: { token } }) => token.fontFamily};
    font-size: ${({ theme: { token } }) => token.fontSize}px;
    font-style: normal;
    font-weight: ${({ theme: { token } }) => token.fontWeight};
    line-height: ${({ theme: { token } }) => token.lineHeight};
  }
`;

const ModalActions = styled.div<{ theme: { token: GlobalToken } }>`
  padding: ${({ theme: { token } }) => `0 ${token.padding}px ${token.paddingLG}px`};
  display: flex;
  justify-content: flex-end;
  align-items: center;
  background: transparent;
`;

export default ConfirmationModal;
